import { useState } from 'react'
import { useDebounce } from 'react-use'

import { CircularProgress } from '../../shared/NarusMaterial'

import styles from './table.module.css'

interface Props {
  loading: boolean
  delay?: number
}

export function DelayedLoading ({ loading, delay = 1000 }: Props): JSX.Element | null {
  let [ showLoading, setShowLoading ] = useState(false)

  useDebounce(() => {
    setShowLoading(loading)
  }, loading ? delay : 0, [ loading ])

  if (!showLoading) {
    return null
  }

  return (
    <div className={styles.loadingContainer}>
      <CircularProgress />
    </div>
  )
}
